import { render, staticRenderFns } from "./huiVisitors.vue?vue&type=template&id=28d8a9d4&scoped=true"
import script from "./huiVisitors.vue?vue&type=script&lang=js"
export * from "./huiVisitors.vue?vue&type=script&lang=js"
import style1 from "./huiVisitors.vue?vue&type=style&index=1&id=28d8a9d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d8a9d4",
  null
  
)

export default component.exports